import axiosInstance from "../../Lib/axios";
import {WorkOrderWrapper} from './workOrderWrapper';
import {
  GET_ACCOUNT_LISTING_SUCCESSFULLY,
  GET_ACCOUNT_LISTING_FAILED,
  GET_TAB_DATA_SUCCESSFULLY,
  GET_TAB_DATA_FAILED,
  ADD_LOG_PAYMENT_SUCCESSFULLY,
  ADD_LOG_PAYMENT_FAILED,
  DELETE_LOG_PAYMENT_SUCCESSFULLY,
  DELETE_LOG_PAYMENT_FAILED,
  GET_EXPIRED_CARD_SUCCESSFULLY,
  GET_EXPIRED_CARD_FAILED,
  RESEND_INVOICE_FAILED,
  RESEND_INVOICE_SUCCESSFULLY,
  VOID_INVOICE_SUCCESSFULLY,
  VOID_INVOICE_FAILED,
  SALES_BY_ITEM_SUCCESSFULLY,
  SALES_BY_ITEM_FAILED,
  OVERVIEW_INVOICE_SUCCESSFULLY,
  OVERVIEW_INVOICE_FAILED,
  GET_AGGING_SUMMARY_SUCCESSFULLY,
  GET_AGGING_SUMMARY_FAILED,
  SUSPEND_AGGING_SUMMARY_SUCCESSFULLY,
  SUSPEND_AGGING_SUMMARY_FAILED,
  GET_MONTHLY_FORECAST_SUCCESSFULLY,
  GET_MONTHLY_FORECAST_FAILED,
  GET_INVOICE_VIEW_SUCCESSFULLY,
  GET_INVOICE_VIEW_FAILED,
  UPDATE_INVOICE_VIEW_SUCCESSFULLY,
  UPDATE_INVOICE_VIEW_FAILED,
  DELETE_INVOICE_ITEMS_SUCCESSFULLY,
  DELETE_INVOICE_ITEMS_FAILED,
  FINALIZE_INVOICE_SUCCESSFULLY,
  FINALIZE_INVOICE_FAILED,
  PRINT_INVOICE_SUCCESSFULLY,
  PRINT_INVOICE_FAILED,
  SEND_INVOICE_REMINDERS_SUCCESSFULLY,
  SEND_INVOICE_REMINDERS_FAILED,
  GET_PAYMENT_HISTORY_SUCCESSFULLY,
  GET_PAYMENT_HISTORY_FAILED,
  GET_PAYMENT_HISTORY_NEW_SUCCESSFULLY,
  GET_PAYMENT_HISTORY_NEW_FAILED,
  GET_INVOICE_DESCRIPTION_SUCCESSFULLY,
  GET_INVOICE_DESCRIPTION_FAILED,
  GET_QUICKBOOKS_SYNC_SUCCESSFULLY,
  GET_QUICKBOOKS_SYNC_FAILED, 
  REFUND_PAYMENT, 
  REFUND_PAYMENT_FAILED, 
  GET_SALES_TAX_SUMMARY, 
  GET_SALES_TAX_SUMMARY_FAILED,
  BATCH_INVOICE_SUCCESSFULLY, 
  BATCH_INVOICE_FAILED,
  GET_STAX_CUSTOMER_SUCCESSFULLY,
  GET_STAX_CUSTOMER_FAILED,
  GET_LAST_THREE_PAYMENTS_SUCCESSFULLY,
  GET_LAST_THREE_PAYMENTS_FAILED,
  POST_PAYMENT_HISTORY_SUCCESSFULLY,
  POST_PAYMENT_HISTORY_FAILED,
  DELETE_PAYMENT_HISTORY_SUCCESSFULLY,
  DELETE_PAYMENT_HISTORY_FAILED,
  GET_PAYMENT_SUCCESSFULLY,
  GET_PAYMENT_FAILED,
  GET_WORK_ORDER_TYPE_DESCRIPTION_SUCCESSFULLY,
  GET_WORK_ORDER_TYPE_DESCRIPTION_FAILED,
  GET_WORK_ORDERS_REPORT_SUCCESSFULLY,
  GET_WORK_ORDERS_REPORT_FAILED,
  GET_WORK_ORDERS_SUMMARY_SUCCESSFULLY,
  GET_WORK_ORDERS_SUMMARY_FAILED,
  GET_WORK_ORDERS_SUCCESSFULLY,
  GET_WORK_ORDERS_FAILED,
  POST_WORK_ORDERS_SUCCESSFULLY,
  POST_WORK_ORDERS_FAILED,
  POST_WORK_ORDERS_GENERATE_INVOICE_SUCCESSFULLY,
  POST_WORK_ORDERS_GENERATE_INVOICE_FAILED,
  INVOICE_PROCESS_SUCCESSFULLY,
  INVOICE_PROCESS_FAILED,
  INVOICE_EMAIL_SEND_SUCCESSFULLY,
  INVOICE_EMAIL_SEND_FAILED,
  GET_MONTHLY_FORECAST_TOTAL_SUCCESSFULLY,
  GET_MONTHLY_FORECAST_TOTAL_FAILED,
  GET_ALL_ACCOUNT_LIST_SUCCESSFULLY,
  GET_ALL_ACCOUNT_LIST_FAILED
} from "../types";
import { PaymentWrapper } from "./PaymentWrapper";

// Get all Account
export const getAccountListing = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice/`, { params })
      .then((response) => {
        dispatch({
          type: GET_ACCOUNT_LISTING_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_ACCOUNT_LISTING_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Get all Account uuid
export const getAllAcountingListUuid = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice-uuid-list/`, { params })
      .then((response) => {
        dispatch({
          type: GET_ALL_ACCOUNT_LIST_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_ALL_ACCOUNT_LIST_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Get Account Tab
export const getAccountListingTab = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice/get_overdue_open_last_invoices/`, { params })
      .then((response) => {
        dispatch({
          type: GET_TAB_DATA_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_TAB_DATA_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Get Manual Payment
export const addManualPayment = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/crm/manual-payment/`, params, {})
      .then((response) => {
        dispatch({
          type: ADD_LOG_PAYMENT_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_LOG_PAYMENT_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Invoice Email Send
export const invoiceEmailSend = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/invoice/email_invoices/`, params)
      .then((response) => {
        dispatch({
          type: INVOICE_EMAIL_SEND_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: INVOICE_EMAIL_SEND_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Invoice Process
export const invoiceProcess = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/invoice/invoice_process/`, params)
      .then((response) => {
        dispatch({
          type: INVOICE_PROCESS_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: INVOICE_PROCESS_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// delete Manualy
export const deleteAccountInvoice = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/invoice/bulk_delete/`, params)
      .then((response) => {
        dispatch({
          type: DELETE_LOG_PAYMENT_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: DELETE_LOG_PAYMENT_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Get Expired Card
export const getExpiredCardListing = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/expiry-payment-method/`, { params })
      .then((response) => {
        dispatch({
          type: GET_EXPIRED_CARD_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_EXPIRED_CARD_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Resend Invoice
export const resendInvoiceAPI = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice/${uuid}/resend_invoice/`)
      .then((response) => {
        dispatch({
          type: RESEND_INVOICE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: RESEND_INVOICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Resend Invoice
export const VoidInvoiceAPI = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice/${uuid}/void_invoice/`)
      .then((response) => {
        dispatch({
          type: VOID_INVOICE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: VOID_INVOICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Sales By Item
export const getSalesByItem = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/sales-by-item/sales_by_item/`, { params })
      .then((response) => {
        dispatch({
          type: SALES_BY_ITEM_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: SALES_BY_ITEM_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//view invoice
export const getOverViewInvoice = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice/overview_invoice/`, { params })
      .then((response) => {
        dispatch({
          type: OVERVIEW_INVOICE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: OVERVIEW_INVOICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get Work Order description
export const getWorkOrderTypeDescription = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/service/${params}/get_line_item/`,{})
      .then((response) => {
        dispatch({
          type: GET_WORK_ORDER_TYPE_DESCRIPTION_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_WORK_ORDER_TYPE_DESCRIPTION_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};


//Get Invoice Descriptions
export const getInvoiceDescription = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/service-order/${params}/get_line_item/`,{})
      .then((response) => {
        dispatch({
          type: GET_INVOICE_DESCRIPTION_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_INVOICE_DESCRIPTION_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Sales by item
export const getAccountAggingSummary = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice/account_receivable_agening/`, { params })
      .then((response) => {
        dispatch({
          type: GET_AGGING_SUMMARY_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_AGGING_SUMMARY_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Agging Summary
export const suspendAccountAggingSummary = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`invoice/suspend_unsuspend_customer/`, { params })
      .then((response) => {
        dispatch({
          type: SUSPEND_AGGING_SUMMARY_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: SUSPEND_AGGING_SUMMARY_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Agging Summary
export const getMonthlyForecast = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/sales-by-item/account_month_forecast/`, { params })
      .then((response) => {
        dispatch({
          type: GET_MONTHLY_FORECAST_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_MONTHLY_FORECAST_FAILED,
              data: error.response.data,
            });
          }
        }else {
          dispatch({
            type: GET_MONTHLY_FORECAST_FAILED,
            data: error.message,
          });

        }
      });
  };
};

//Get Monthly ForCast CSV file
export const getMonthForecastCSV = (params) => {
  return () => {
    return axiosInstance
      .get(`/sales-by-item/account_month_forecast/`, { params })
      .then((response) => {
        let data = response.data;
        let blob = new Blob([data], { type: "application/CSV" });
        
        blob.text().then((csvContent) => {
          // Delete the first row that have the columns name
          const csvFixedContent = csvContent.split("\n").slice(1).join("\n");
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(new Blob([csvFixedContent], { type: "application/CSV" }));
          
          let month = getMonthName(Number(params.created_at__month));
          let year = params.created_at__year;
          let fileName = "Monthly Forecast-"+month+" "+year+".csv";
          link.download = fileName;
          document.body.appendChild(link);
  
          link.click();
          document.body.removeChild(link);
        })
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
        }
      });
  };
};


//View Invoice
export const getSingleInvoice = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice/${params}/`, {})
      .then((response) => {
        dispatch({
          type: GET_INVOICE_VIEW_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_INVOICE_VIEW_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Update Invoice
export const updateSingleInvoice = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/invoice/${params.uuid}/`, { ...params })
      .then((response) => {
        dispatch({
          type: UPDATE_INVOICE_VIEW_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_INVOICE_VIEW_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Delete Invoice Items
export const deleteSingleInvoice = (uuid) => {
  return (dispatch) => {
    return axiosInstance

      .delete(`/invoice-line-item/${uuid}/`, {})
      .then(() => {
        dispatch({
          type: DELETE_INVOICE_ITEMS_SUCCESSFULLY,
          data: { message: "deleted" },
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: DELETE_INVOICE_ITEMS_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//View Invoice
export const approveSendInvoice = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice/${uuid}/finalize-invoice/`, {})
      .then((response) => {
        dispatch({
          type: FINALIZE_INVOICE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: FINALIZE_INVOICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Print Invoice
export const printInvoice = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/invoice/print-invoices/`, params)
      .then((response) => {
        dispatch({
          type: PRINT_INVOICE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: PRINT_INVOICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Send Reminder
export const sendInvoiceReminder = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice/send-reminders/`, { params })
      .then((response) => {
        dispatch({
          type: SEND_INVOICE_REMINDERS_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: SEND_INVOICE_REMINDERS_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get Payment History

export const getPaymentHistory = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/payment-history`, { params })
      .then((response) => {
        dispatch({
          type: GET_PAYMENT_HISTORY_SUCCESSFULLY,
          data: PaymentWrapper(response.data),
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_PAYMENT_HISTORY_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Get a payment
export const getPayment = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/payment/${params}`)
      .then((response) => {
        dispatch({
          type: GET_PAYMENT_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_PAYMENT_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Update Payment
export const postPaymentHistory = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/crm/payment-history`, { params })
      .then((response) => {
        dispatch({
          type: POST_PAYMENT_HISTORY_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: POST_PAYMENT_HISTORY_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Delete Payment
export const deletePaymentLog = (params) => {
  return (dispatch) => {
    return axiosInstance
      .delete(`/crm/manual-payment/${params}`)
      .then((response) => {
        dispatch({
          type: DELETE_PAYMENT_HISTORY_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: DELETE_PAYMENT_HISTORY_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Get all Account
export const getPaymentHistoryNew = (params) => {
  return (dispatch) => {
    dispatch({
      type: GET_PAYMENT_HISTORY_NEW_SUCCESSFULLY,
      // data : testData,          
    });
    return axiosInstance
      .get(`/crm/payment-history`, { params })
      .then((response) => {
        dispatch({
          type: GET_PAYMENT_HISTORY_NEW_SUCCESSFULLY,
          data: response.data,
          // data : testData,          
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_PAYMENT_HISTORY_NEW_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get Last 3 Payment Made
export const getLastThreePayment = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/last-three-payments`, { params })
      .then((response) => {
        dispatch({
          type: GET_LAST_THREE_PAYMENTS_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_LAST_THREE_PAYMENTS_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Quickbooks force sync
export const getQuickbooksSync = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/field-office/${params.uuid}/force-sync-quickbooks/`)
      .then((response) => {
        dispatch({
          type: GET_QUICKBOOKS_SYNC_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_QUICKBOOKS_SYNC_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Refund payment
export const refundPaymentAccounting = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/crm/refund/`, params)
      .then((response) => {
        dispatch({
          type: REFUND_PAYMENT,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          dispatch({
            type: REFUND_PAYMENT_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// Get sales taxes summary
export const getSalesTaxSummary = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/sales-by-item/sales_tax/`, { params })
      .then((response) => {
        dispatch({
          type: GET_SALES_TAX_SUMMARY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SALES_TAX_SUMMARY_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Batch Invoice
export const batchInvoice = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/invoice/batch_invoice/`, { params })
      .then((response) => {
        dispatch({
          type: BATCH_INVOICE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: BATCH_INVOICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Get stax customer detail
export const getStaxCustomerDetail = (id) => {
  return (dispatch) => {
    return axiosInstance
      .get(`crm/stax-customer/${id}`)
      .then((response) => {
        dispatch({
          type: GET_STAX_CUSTOMER_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_STAX_CUSTOMER_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// Work Orders Report
// Get work orders summary and totals for report overview
export const getWorkOrdersSummary = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/services-to-batch-invoice/get-billable-month_total/`, {params})
      .then((response) => {
        dispatch({
          type: GET_WORK_ORDERS_SUMMARY_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_WORK_ORDERS_SUMMARY_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

// Get list of work orders
export const getWorkOrders = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/services-to-batch-invoice/`, {params})
      .then((response) => {
        dispatch({
          type: GET_WORK_ORDERS_SUCCESSFULLY,
          data: WorkOrderWrapper(response?.data),
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_WORK_ORDERS_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

// Send services to batch invoice
export const sendInvoice = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/services-to-batch-invoice/`, params)
      .then((response) => {
        dispatch({
          type: POST_WORK_ORDERS_SUCCESSFULLY,
          data: {message: "Sended"},
        });
      })
      .catch((error) => {
        if ( error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: POST_WORK_ORDERS_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

// Generate Invoice
export const generateInvoice = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/services-to-batch-invoice/generate-invoice/`, params)
      .then((response) => {
        dispatch({
          type: POST_WORK_ORDERS_GENERATE_INVOICE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: POST_WORK_ORDERS_GENERATE_INVOICE_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
}

export const getMonthlyForecastTotal = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/sales-by-item/account_month_forecast/`, { params })
      .then((response) => {
        dispatch({
          type: GET_MONTHLY_FORECAST_TOTAL_SUCCESSFULLY,
          data: response.data.results.total,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_MONTHLY_FORECAST_TOTAL_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

function getMonthName(month){
  const d = new Date();
  d.setMonth(month-1);
  const monthName = d.toLocaleString("default", {month: "long"});
  return monthName;
}